// 调查问券

import { BrokerType } from './model/questionModel';
import { defHttp } from '/@/utils/http/axios';

enum Api {
  // 查询memberCode是否存在，若存在返回会员信息
  checkMember = '/member/surveys/check',
  // 提交问券
  submitQuestion = '/ex-member/surveys/submit',
  // 查询专业投资人声明
  queryProfessionalInvestor = '/member/pi-statement/content',
  // 投资人声明确认
  confirmProfessionalInvestor = '/member/pi-statement/confirm',
  // 查询券商
  queryBroker = '/ex-member/broker/list-all',
}
/**
 * [memberCode查询](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%B0%83%E6%9F%A5%E9%97%AE%E5%8D%B7/checkAndGetSurveyMemberInfo)
 */
export const checkMember = (params) => {
  return defHttp.get<{
    memberCode: string;
    memberName: string;
    isRegulatedFinancial: boolean;
    submitTimesOverLimit: boolean;
  }>({
    url: Api.checkMember,
    params,
  });
};

/**
 * [提交问券](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%B0%83%E6%9F%A5%E9%97%AE%E5%8D%B7/submit)
 */
export const submitQuestion = (params) => {
  return defHttp.post({
    url: Api.submitQuestion,
    params,
  });
};

export const queryProfessionalInvestorApi = () => {
  return defHttp.get({
    url: Api.queryProfessionalInvestor,
  });
};

export const confirmProfessionalInvestorApi = (params) => {
  return defHttp.post({
    url: Api.confirmProfessionalInvestor,
    params,
  });
};
/**
 * [查询券商](https://exmt-dev1-api.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E5%88%B8%E5%95%86/listAll)
 */
export const queryBroker = () => {
  return defHttp.get<BrokerType[]>({
    url: Api.queryBroker,
  });
};
